import { Reveal } from "./Reveal";

const FINISHES = ["Copper", "Matte Black", "Gloss White", "Color-Matched Aluminum", "Galvalume"];

export const BrandStatement = () => (
  <section
    className="hero-grid-lines relative overflow-hidden bg-ink2/40 pb-20 pt-28 lg:pb-32 lg:pt-40"
    style={{ clipPath: "polygon(0 3.5rem, 100% 0, 100% 100%, 0 100%)" }}
    data-testid="brand-statement-section"
  >
    <div className="pointer-events-none absolute -bottom-40 right-1/4 h-[420px] w-[420px] rounded-full bg-orange-500/10 blur-[140px]" />
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <Reveal>
        <div className="flex items-center gap-4">
          <span className="h-px w-10 bg-orange-500" />
          <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-orange-500">
            Our Promise
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 max-w-5xl font-display text-4xl font-extrabold uppercase leading-[0.98] text-white sm:text-6xl lg:text-7xl">
          We work <span className="text-outline">with</span> you to bring{" "}
          <span className="font-serif normal-case italic tracking-normal text-orange-500">
            your aesthetic alive
          </span>
        </h2>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">
          Gutters and drainage shouldn't just work — they should look like they
          were born on your home. Pick your profile, metal and finish, and we
          custom-fabricate on-site to match your trim, roofline and style.
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-10 flex flex-wrap gap-3" data-testid="finish-options">
          {FINISHES.map((f) => (
            <span
              key={f}
              className="rounded-full border border-white/10 bg-white/5 px-5 py-2.5 font-display text-sm font-semibold uppercase tracking-wider text-slate-200 transition-colors hover:border-orange-500/50 hover:text-orange-500"
            >
              {f}
            </span>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
